var AdaptiveImage = require("../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "src/assets/web/images/people_icon.png",
    width: 520,
    height: 339
});